import { combineReducers } from 'redux';
import { simulationReducers } from './simulation/simulation.state';
import { currentOrderReducers } from './order.state';

import { simulationMiddlewares } from './simulation/simulation.middlewares';
import { currentOrderMiddlewares } from './order.middlewares';

export const orderMiddlewares = [
    currentOrderMiddlewares,
    simulationMiddlewares,
];

export const orderReducers = combineReducers({
    currentOrder: currentOrderReducers,
    simulation: simulationReducers,
});
